import {
  PaginationPageSize,
  Operator,
  BillingStatus,
  QueryType,
  UssdSessionType,
  UssdSessionCloseReasonQuery,
  WapSessionCloseReasonQuery,
  WapSessionType,
  VoiceSessionCloseReasonQuery
} from '../../../api/interfaces';

// Values based on keys in the API schema
export enum FILTERS {
  FROM = 'from',
  TO = 'to',
  SHORTCODE = 'shortcode',
  APP_ID = 'app_id',
  OPERATOR = 'operator',
  OPERATORS = 'operators',
  OPERATION_ID = 'operation_id',
  OPERATION_IDS = 'operationIds',
  MSISDN = 'msisdn',
  CUSTOMER_MSISDN = 'customer_msisdn',
  SENDERS_MSISDNS = 'sendersMsisdns',
  PAGE_SIZE = 'page_size',
  SKU = 'sku',
  SKUS = 'skus',
  STATUS = 'status',
  STATUSES = 'statuses',
  MERCHANT_CODE = 'merchant_code',
  QUERY_TYPE = 'query_type',
  RECIPIENT_MSISDN = 'recipient_msisdn',
  ACQUIRER_MSISDN = 'acquirer_msisdn',
  ACQUIRER_MSISDNS = 'acquirerMsisdns',
  PROVIDER_NAME = 'provider_name',
  AUTHENTICATION_METHOD = 'authentication_method',
  SESSION_TYPE = 'session_type',
  SESSION_TAG = 'session_tag',
  SESSION_CLOSE_REASON = 'session_close_reason'
}

export const DEFAULT_FILTER_OPTIONS = {
  PAGE_SIZE: '100' as PaginationPageSize
};

export const OPERATORS: Operator[] = ['airtel', 'glo', 'mtn', '9mobile'];

export const PAGE_SIZES: PaginationPageSize[] = ['25', '50', DEFAULT_FILTER_OPTIONS.PAGE_SIZE];

export const BILLING_STATUSES: BillingStatus[] = ['success', 'failure', 'unknown'];

export const VOICE_SESSION_CLOSE_REASONS_QUERY: VoiceSessionCloseReasonQuery[] = [
  'END',
  'ABANDON',
  'TIMEOUT',
  'NOT_CLOSED_YET'
];

export const WAP_SESSION_TYPES: WapSessionType[] = ['PUSH', 'CUSTOMER_INITIATED'];

export const WAP_SESSION_CLOSE_REASONS_QUERY: WapSessionCloseReasonQuery[] = [
  'END',
  'ABANDON',
  'TIMEOUT',
  'NOT_CLOSED_YET'
];

export const USSD_SESSION_TYPES: UssdSessionType[] = ['P2A', 'A2P', 'A2A'];

export const USSD_SESSION_CLOSE_REASONS_QUERY: UssdSessionCloseReasonQuery[] = [
  'END',
  'ABANDON',
  'TIMEOUT',
  'NOT_CLOSED_YET'
];

export const CUSTOMER_VALIDATION_QUERY_TYPES: QueryType[] = [
  'NAME_AND_MSISDN',
  'NAME_AND_BANK_ACCOUNT',
  'MSISDN_AND_DATE_OF_BIRTH',
  'BVN_AND_NAME_AND_DATE_OF_BIRTH'
];
